<app-ventilation-mode-panel> </app-ventilation-mode-panel>
<app-ventilation-panel
  *ngIf="
    (ventilationMode$ | async | ready).properties?.value?.value !==
    VentilationOperatingModesActivePrograms.sensorDriven
  "
></app-ventilation-panel>

<h2
  *ngIf="(ventilationBypassMode$ | async | ready) || (isVentilationQuickSelectionsVisible$ | async)"
>
  {{ '+SETTINGS.TITILE' | translate }}
</h2>
<div class="settings-wrapper">
  <app-ventilation-bypass
    data-at-bypass-section
    *ngIf="ventilationBypassMode$ | async | ready"
  ></app-ventilation-bypass>
  <app-ventilation-quick-selections
    *ngIf="isVentilationQuickSelectionsVisible$ | async"
  ></app-ventilation-quick-selections>
  <app-ventilation-automated-mode-level
    *ngIf="ventilationAutomatedModeLevel$ | async | ready"
  ></app-ventilation-automated-mode-level>
  <ng-container *ngIf="remoteControllerDevices.length > 0">
    <app-vitotrol-remote-controller [featureName]="featureNames.ventilationRemoteController">
    </app-vitotrol-remote-controller>
  </ng-container>
  <app-ventilation-frost-protection
    *ngIf="ventilationHeatExchangerType$ | async | ready as ventilationHeatExchangerType"
    [data]="ventilationHeatExchangerType"
  ></app-ventilation-frost-protection>
</div>

<ng-container *ngIf="installationFeaturesStore.isVentilationDiagnosticInformationVisible$ | async">
  <h2>{{ '+INSTALLATIONS.INSTALLATION.VENTILATION.DIAGNOSTIC_INFORMATION_TITLE' | translate }}</h2>
  <app-ventilation-diagnostic-information></app-ventilation-diagnostic-information>
</ng-container>

<ng-container *ngIf="installationFeaturesStore.isVentilationSensorReadingVisible$ | async">
  <h2>{{ '+INSTALLATIONS.INSTALLATION.WARM_WATER.TITLE_SENSOR_READINGS' | translate }}</h2>
  <app-ventilation-sensor-readings></app-ventilation-sensor-readings>
</ng-container>
<ng-container
  *ngIf="gatewayStore.getVitotrol300EDevicesNotAssignedToRoom$ | async as unassignRoomVitotrol300E"
>
  <ng-container *ngIf="unassignRoomVitotrol300E.length">
    <h2>{{ '+INSTALLATIONS.INSTALLATION.REMOTE_CONTROLLER.TITLE' | translate }}</h2>
    <app-ventilation-remote-controller-readings
      *ngFor="let remoteDevice of unassignRoomVitotrol300E"
      [deviceId]="remoteDevice.device.id"
    ></app-ventilation-remote-controller-readings>
  </ng-container>
</ng-container>
